import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

import {
  orderDetails,
  orderList,
  orderStatic,
  orderTypeParameter,
  orderTypeParameterFilter,
  editOrder,
} from "./orderApi";

const initialState = {
  order: [],
  orderList: [],
  orderStatics: [],
  orderParameterList: [],
  orderParameterFilterList: [],
  status: "",
};

export const orderDetailsAsync = createAsyncThunk(
  "order/details",
  async (data, { dispatch }) => {
    const response = await orderDetails(data.ambiente, data.orderId);
    return response;
  }
);

export const orderListAsync = createAsyncThunk(
  "order/list",
  async (data, { dispatch }) => {
    const response = await orderList(
      data.page,
      data.pagesize,
      data.fechainicio,
      data.fechafinal,
      data.ambiente,
      data.estado,
      data.campoBusqueda,
      data.busqueda
    );
    dispatch(setList(response));
    return response;
  }
);

export const orderStaticAsync = createAsyncThunk(
  "order/static",
  async (data, { dispatch }) => {
    const response = await orderStatic(
      data.ambiente,
      data.fechainicio,
      data.fechafinal
    );
    dispatch(setStatics(response));
    return response;
  }
);

export const orderParameterAsync = createAsyncThunk(
  "order/ordenParametros",
  async (data, { dispatch }) => {
    const response = await orderTypeParameter();
    dispatch(setOrderTypeParameter(response));
    return response;
  }
);

export const orderParameterFilterAsync = createAsyncThunk(
  "order/ordenParametrosFilter",
  async (data, { dispatch }) => {
    const response = await orderTypeParameterFilter();
    dispatch(setOrderTypeParameterFilter(response));
    return response;
  }
);

export const orderEditAsync = createAsyncThunk(
  "order/ordenEdit",
  async (data, { dispatch }) => {
    const response = await editOrder(
      data.orderId,
      data.ambiente,
      data.nombre,
      data.apellido,
      data.telefono,
      data.direccion
    );
    return response;
  }
);

export const orderSlice = createSlice({
  name: "order",
  initialState,
  reducers: {
    setList: (state, action) => {
      state.orderList = action.payload;
    },
    setStatics: (state, action) => {
      state.orderStatics = action.payload;
    },
    setOrderTypeParameter: (state, action) => {
      state.orderParameterList = action.payload;
    },
    setOrderTypeParameterFilter: (state, action) => {
      state.orderParameterFilterList = action.payload;
    },
  },

  extraReducers: (builder) => {
    builder
      .addCase(orderDetailsAsync.pending, (state) => {
        state.status = "Loading";
      })
      .addCase(orderDetailsAsync.fulfilled, (state, action) => {
        state.order = action.payload;
        state.status = "idle";
      })
      .addCase(orderListAsync.pending, (state) => {
        state.status = "Loading";
      })
      .addCase(orderListAsync.fulfilled, (state) => {
        state.status = "idle";
      })
      .addCase(orderStaticAsync.pending, (state) => {
        state.status = "Loading";
      })
      .addCase(orderStaticAsync.fulfilled, (state) => {
        state.status = "idle";
      })
      .addCase(orderParameterAsync.pending, (state) => {
        state.status = "Loading";
      })
      .addCase(orderParameterAsync.fulfilled, (state) => {
        state.status = "idle";
      })
      .addCase(orderParameterFilterAsync.pending, (state) => {
        state.status = "Loading";
      })
      .addCase(orderParameterFilterAsync.fulfilled, (state) => {
        state.status = "idle";
      })
      .addCase(orderEditAsync.pending, (state) => {
        state.status = "Loading";
      })
      .addCase(orderEditAsync.fulfilled, (state) => {
        state.status = "idle";
      });
  },
});

export const {
  setList,
  setStatics,
  setOrderTypeParameter,
  setOrderTypeParameterFilter,
} = orderSlice.actions;

export const staticOrders = (state) => state.order.orderStatics;
export const orderSelect = (state) => state.order.order;
export const orders = (state) => state.order.orderList;
export const status = (state) => state.order.status;
export const orderParameters = (state) => state.order.orderParameterList;
export const orderParameterFilter = (state) =>
  state.order.orderParameterFilterList;

export default orderSlice.reducer;
